import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { Node, NodeEntry } from '@alfresco/js-api';
import { NodeActionsService } from '@adw/projects/aca-content/src/lib/services/node-actions.service';

@Injectable({
  providedIn: 'root',
})
export class WkNodeActionsService {
  get contentCopied(): Subject<NodeEntry[]> {
    return this.nodeActionsService.contentCopied;
  }

  get contentMoved(): Subject<any> {
    return this.nodeActionsService.contentMoved;
  }

  get moveDeletedEntries(): any[] {
    return this.nodeActionsService.moveDeletedEntries;
  }

  constructor(private readonly nodeActionsService: NodeActionsService) {}

  copyNodes(
    contentEntities: any[],
    permission: string = null
  ): Subject<string> {
    return this.nodeActionsService.copyNodes(contentEntities, permission);
  }

  moveNodes(
    contentEntities: any[],
    permission: string = null
  ): Subject<string> {
    return this.nodeActionsService.moveNodes(contentEntities, permission);
  }

  getEntryParentId(node: Node): string {
    return this.nodeActionsService.getEntryParentId(node);
  }

  flatten(nDimArray: any[]): any[] {
    return this.nodeActionsService.flatten(nDimArray);
  }

  moveNodeAction(nodeEntry: any, selectionId: string): Observable<any> {
    return this.nodeActionsService.moveNodeAction(nodeEntry, selectionId);
  }
}
